import React from 'react'
import { Helmet } from 'react-helmet';
import { Link, useParams } from 'react-router-dom';
import statesCitiesData from '../data/StateCityData/CityData';
import productsData from '../data/StateCityData/ProductsData';

export const PPDanaStateCityDetails = () => {
  const { slug } = useParams();


 const formatSlug = (slug) => {
  return slug?.toLowerCase().replace(/\s+/g, '-');
};

const formatDisplaySlug = (slug) => {
  return slug?.replace(/-/g, ' ');  
};

const [productSlugPart, citySlugPart] = slug?.split('-in-');

const ppDanaProduct = productsData.find(product => formatSlug(product.name) === productSlugPart);

   const matchingProducts = productsData.filter(product =>
        formatSlug(product.name).startsWith(productSlugPart)
    );

    const validLocationSlugs = statesCitiesData.flatMap(item => [
        formatSlug(item.state),
        ...item.cities.map(formatSlug)
      ]);

    const isValidCityOrState = validLocationSlugs.includes(citySlugPart);

    if (!ppDanaProduct || !isValidCityOrState) {
        return <h1 className='products_not_found'>404 - Product Not Found</h1>;
      }

      const toTitleCase = (text) => {
        return text .replace(/-/g, ' ') .split(' ') .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(' '); 
      };
      
     
  return (
    <>
    
{/* meta description and meta keyword start */}
<Helmet>
<title>{toTitleCase(formatDisplaySlug(slug))} | High-Quality Recycled & Virgin {toTitleCase(formatDisplaySlug(slug))} – Vanshika Plastic</title>

{/* Meta Description for SEO */}
<meta name="description" content={`Vanshika Plastic is a leading ${formatDisplaySlug(slug)}, offering high-quality recycled and virgin polypropylene ${formatDisplaySlug(slug)} for injection molding, automotive, and industrial applications. Contact us for durable and cost-effective plastic raw materials.`} />

{/* Meta Keywords for SEO */}
<meta name="keywords" content={`${formatDisplaySlug(slug)}, recycled ${formatDisplaySlug(slug)}, virgin ${formatDisplaySlug(slug)}, PP granules, PP plastic raw material, industrial ${formatDisplaySlug(slug)}, high-quality ${formatDisplaySlug(slug)}`} />

{/* Robots Meta Tag */}
<meta name="robots" content="index, follow" />

{/* Open Graph Meta Tags */}
<meta property="og:title" content={`${formatDisplaySlug(slug)} | High-Quality Recycled & Virgin ${formatDisplaySlug(slug)} – Vanshika Plastic`} />
<meta property="og:description" content={`Vanshika Plastic is a leading ${formatDisplaySlug(slug)}, offering high-quality recycled and virgin polypropylene ${formatDisplaySlug(slug)} for injection molding, automotive, and industrial applications. Contact us for durable and cost-effective plastic raw materials.`} />
<meta property="og:image" content={`https://www.vanshikaplastic.com/${ppDanaProduct?.image}`} />
<meta property="og:url" content={`https://www.vanshikaplastic.com/${formatSlug(slug)}`} />
<meta property="og:type" content="website" />

{/* Twitter Card Meta Tags */}
<meta name="twitter:card" content={`https://www.vanshikaplastic.com/${ppDanaProduct?.image}`} />
<meta name="twitter:title" content={`${formatDisplaySlug(slug)} | High-Quality Recycled & Virgin pp-dana – Vanshika Plastic`} />

<meta name="twitter:description" content={`Vanshika Plastic is a trusted ${formatDisplaySlug(slug)}, offering high-quality recycled and virgin ${formatDisplaySlug(slug)} for packaging, film extrusion, and molding applications. Contact us for durable and cost-effective plastic raw materials.`} />
<meta name="twitter:image" content={`https://www.vanshikaplastic.com/${ppDanaProduct?.image}`} />

{/* Canonical URL Tag */}
<link rel="canonical" href={`https://www.vanshikaplastic.com/${formatSlug(slug)}`} />

      </Helmet>
{/* meta description and meta keyword end */}

      {/* Page title section start */}
      <section className="page_title_mkp_section">
        <div className="page_ti_overly_mkp_div">
          <div className="container">
            <div className="row">
              {/* Column start */}
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-sm-12 col-12">
                <div className="page_title_tax_mkp_main_div">
                  <div className="page_title_tax_mkp_div">
                    <h1>{formatDisplaySlug(slug)}</h1>
                    <ul>
                      <li><Link to="/">Home</Link></li>
                      <li>{formatDisplaySlug(slug)}</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* Column end */}
            </div>
          </div>
        </div>
      </section>
      {/* Page title section end */}

      {/* Product details section start */}
      <section className="products_dt_section">
        <div className="container">
          <div className="row justify-content-center">
            {/* Image section */}
            <div className="col-lg-4">
              <div className="product_details_img_box">
                <img src={ppDanaProduct?.image}/>
                <div className="prodt_enqyury_btn_overlay">
                    <a href="/contact-us">Enquiry Now</a> 
                </div>
              </div>
            </div>
            {/* Details section */}

            {/* col start */}
            <div className="col-lg-7">
              <div className="product_dt_description">
                <h2>{formatDisplaySlug(slug)}</h2>
                <p>At Vanshika Plastic, we specialize in manufacturing and supplying high-quality {formatDisplaySlug(slug)} (Polypropylene Dana), catering to a wide range of plastic processing industries. Our {formatDisplaySlug(slug)} is available in virgin, recycled, and colored forms, offering flexibility, durability, and cost-effectiveness to meet every manufacturing need.</p>

                <h3>Types of {formatDisplaySlug(slug)} We Offer</h3>
                <ol>
                    <li><strong>Virgin {formatDisplaySlug(slug)} –</strong> Made from pure polypropylene for high-performance applications where strength, purity, and consistency are critical.</li>
                    <li><strong>Recycled {formatDisplaySlug(slug)} –</strong> An eco-friendly and budget-conscious option created from post-industrial and post-consumer waste, perfect for general plastic goods.</li>
                    <li><strong>Colored {formatDisplaySlug(slug)} –</strong> Available in various shades like red, green, blue, yellow, and black—ideal for colored product manufacturing.</li>
                    <li><strong>Natural/Transparent {formatDisplaySlug(slug)} –</strong> Best suited for clean-finish and semi-transparent applications.</li>
                </ol>
   
              </div>
              

             
            </div>
            {/* col end */}

             {/* col start */}
             <div className="col-lg-11">
              <div className="product_dt_description">
               <h4>Applications</h4>
               <p>Our {formatDisplaySlug(slug)} is widely used in:</p>
               <ul>
                <li>Household plastic products (buckets, tubs, mugs)</li>
                <li>Furniture (plastic chairs, tables, stools)</li>
                <li>Automotive components (dashboards, battery casings)</li>
                <li>Packaging solutions (crates, containers, films)</li>
                <li>Electrical appliances and parts</li>
                <li>Toys, kitchenware, and more</li>
               </ul>

               <h5>Why Choose Vanshika Plastic?</h5>
               <ul>
                <li>Premium quality granules tested for consistency and strength</li>
                <li>Eco-conscious production using advanced recycling techniques</li>
                <li>Custom color matching available on request</li>
                <li>Competitive pricing and bulk availability</li>
                <li>Timely delivery and excellent customer support</li>
               </ul>

               <p>At Vanshika Plastic, we are committed to delivering durable and cost-effective {formatDisplaySlug(slug)}  that meets the evolving needs of plastic product manufacturers across industries.</p>
   
              </div>
         
             
            </div>
            {/* col end */}
            

          </div>
        </div>
      </section>
      {/* Product details section end */}


      {/* ==============  all cities collapse div start ================ */}
     <div className="container">
       <div className="row justify-content-center">
       <div className="col-lg-11">
        <div className="all_cities_collapse_div">

{/* collapse btn div start */}
<a data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">Dot</a>

{/* collapse btn div end */}

{/* === */}
<div class="collapse" id="collapseExample">
<div class="all_cities_lists">

{/* state and city list section start */}
<section className="state_city_section">
{/* container start */}
<div className="container">
    {/* row start */}

    {matchingProducts?.map((product, productIndex)=>{
        return(
            <>
             <div className="row" key={productIndex}>
               {/* title div start  */}
               <div className="state_title_div">
               <h2>{product?.name}</h2>
               </div>
               {/* title div end */}
    {statesCitiesData?.map((ele, stateIndex) => {
      return (
        <div className="col-lg-4 col-md-6 col-sm-12 col-12" key={`${productIndex}-${stateIndex}`}>
          <div className="state_city_dropdown_main_div">
            <li>
              <Link to={`/${formatSlug(product.name)}-in-${formatSlug(ele.state)}`}>
              {product.name} in {ele.state}</Link>
              <span
                data-bs-toggle="collapse"
                href={`#collapseExample${productIndex}-${stateIndex}`}
                aria-expanded="false"
                aria-controls={`collapseExample${productIndex}-${stateIndex}`}
                className="fa fa-angle-down"
              ></span>
            </li>

            <div className="collapse" id={`collapseExample${productIndex}-${stateIndex}`}>
              <div className="city_name_list_main_div">
                {ele?.cities?.map((city, cityIndex) => {
                  return (
                    <ul key={cityIndex}>
                      <li><Link to={`/${formatSlug(product?.name)}-in-${formatSlug(city)}`}>
                      <span className="fa fa-angle-double-right"></span>
                              {product?.name} in {city}
                       </Link></li>
                    </ul>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      );
    })}
  </div>
            </>
        )
    })}
 
    {/* row start */}
</div>
{/* container end */}
</section>
{/* state and city list section end */}
</div>
</div>
{/* === */}



</div>
        </div>
       </div>
     </div>
      {/* ==============  all cities collapse div end ================ */}



      

    </>
  )
};

export default PPDanaStateCityDetails;